<template>
    <footer v-if="showFooter">
      <b-container>
        <b-row>
          <b-col sm="4">
            <h2>من نحن</h2>
            <p>متجر اردني يهتم بيبع الاجهزه والاكسسورات المتميزه</p>
          </b-col>
          <b-col sm="4">
            <h2>روابط مهمة</h2>
            <b-row>
              <b-col cols="6">
                <router-link to="/">المتجر</router-link>
                <br>
                <a href="#">سياسة الارجاع</a>
              </b-col>
              <b-col>
                <a href="#">كيف استلم الطلب بطريقة امنه في ظل انتشار وباء كورونا ؟  </a>
              </b-col>
            </b-row>
          </b-col>
          <!-- <b-col sm="4">
          <h2>تابعنا على الشبكات الاجتماعية</h2>
          <font icon="facebook" />  
          </b-col> -->
        </b-row>
      </b-container>
      <div class="bottom-footer">

        <b-container class="text-center">
          <p>جميع الحقوق محفوظة © {{new Date().getFullYear()}} </p>
        </b-container>
      </div>
    </footer>
</template>
<script type="text/javascript">
  export default {
    name: 'Footer',
    data() {
      return {
        showFooter: true
      }
    },

  }
</script>
